import React from 'react';

const EmptyRow = () => (
  <div key="empty-0" style={{animationDelay: `0.4s`}} className={`empty-row animate__animated animate__fadeInUp`}>
    Results should show up as soon as a match is over.
  </div>
);

export default EmptyRow;